<template>
  <div id="app">
 
    <main>
      <router-view/>
    </main>
    <b-loading :is-full-page="true" :active.sync="appIsLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Toolbar from '@/components/Toolbar.vue'


export default {

  computed:{
    ...mapGetters(['appIsLoading'])
  },
  
  methods:{

    cardModal() {
        this.$modal.open({
            parent: this,
            component: ModalForm,
            hasModalCard: true
        })
    }
  },

  components:{
    Toolbar
  }
}
</script>


<style>

html, body {
  box-sizing: border-box;
  margin:0;
  padding:0;

}


*, *:before, *:after {
  box-sizing: inherit;
}


#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

main{
  grid-area:main;
  
}

@media only screen and (max-width: 1087px) {
 
 
}


</style>

<style lang="scss">

  // Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #4DBA87;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);



// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

//Settings
 $radius:4px;
// $radius-small:0px;
// $radius-large:0px;
// $radius-rounded:0px;
 $control-radius:4px;

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

//Navbar
$navbar-height: 4rem;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

</style>